(function() {
    'use strict';

    angular
        .module('atheer.core')
        .factory('sanitizeHtml', sanitizeHtml);

    /**
     * Sanitize untrusted HTML before $sce.trustAsHtml / ng-bind-html.
     * Policy mirrors ngx/src/app/shared/utils/sanitize-html-for-angular.ts (embeds + common attrs).
     */
    function sanitizeHtml($log, $window) {
        var CONFIG = {
            ALLOW_DATA_ATTR: true,
            ADD_ATTR: ['matTooltip', 'contenteditable'],
            ADD_TAGS: ['iframe']
        };

        return function sanitize(value) {
            if (value === null || angular.isUndefined(value)) {
                return '';
            }
            var s = angular.isString(value) ? value : String(value);
            if (s === '') {
                return '';
            }
            if (angular.isUndefined($window.DOMPurify) || !angular.isFunction($window.DOMPurify.sanitize)) {
                $log.error('DOMPurify is not loaded; refusing to treat HTML as safe.');
                return '';
            }
            return $window.DOMPurify.sanitize(s, CONFIG);
        };
    }

    sanitizeHtml.$inject = ['$log', '$window'];
})();
